import React, {useState} from 'react';
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  Box,
  IconButton,
  InputAdornment,
  FormLabel
} from '@mui/material';
import Iconify from 'src/minimal-components/iconify';
import TextField from '@mui/material/TextField';
import {Controller, useFormContext} from 'react-hook-form';


interface SingleQuestionTypeProps {
  field?: any;
  name?: string;
}

const SingleQuestionTypeFeedback: React.FC<SingleQuestionTypeProps> = ({
  field,
  name
}) => {
  const [hoveredItemId, setHoveredItemId] = useState<number | null>(null);
  const {control} = useFormContext();
  const handleAddChoice = () => {
    if (field) {
      const newIDs = field.value.length
        ? field.value[field.value.length - 1].id + 1
        : 1;
      const newChoices = [...field.value, {id: newIDs, value: ''}];
      field.onChange(newChoices);
    }
  };

  const handleChoiceChange = (id: number, value: string) => {
    if (field) {
      const fieldvalue = field.value.map(
        (choice: {id: number; value?: any}) => {
          if (choice.id === id) {
            // Return the updated object with the new value
            return {...choice, value};
          }
          // Return the unchanged object
          return choice;
        }
      );
      field.onChange(fieldvalue);
    }
  };

  const handleDeleteChoice = (id: number) => {
    if (field) {
      field.onChange(
        field.value.filter((choice: {id: number}) => choice.id !== id)
      );
    }
  };
  return (
    <>
      <div>
        <FormControl component="fieldset">
          <FormLabel component="legend">Answer</FormLabel>
          <Controller
            name={name || ''}
            control={control}
            render={({field, fieldState: {error}}) => (
              <RadioGroup
                name="answer-choices"
                // value={correctAnswer}
                // onChange={e =>
                //   setCorrectAnswer && setCorrectAnswer(Number(e.target.value))
                // }
              >
                {field.value.map((choice: {id: number; value: string}) => (
                  <Box
                    key={choice.id}
                    sx={{display: 'flex', alignItems: 'center', mb: 1}}>
                    <FormControlLabel
                      onMouseEnter={() => setHoveredItemId(choice.id)}
                      onMouseLeave={() => setHoveredItemId(null)}
                      value={choice.id}
                      control={<Radio disabled />}
                      label={
                        <TextField
                          key={choice.id}
                          fullWidth
                          variant="outlined"
                          value={choice.value}
                          sx={{minWidth: '69vh'}}
                          onChange={e =>
                            handleChoiceChange(choice.id, e.target.value)
                          }
                          error={!!error}
                          helperText={
                            error && error?.message
                              ? error?.message
                              : (error as any)?.[choice.id - 1]?.value?.message
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() => handleDeleteChoice(choice.id)}
                                  edge="end"
                                  sx={{
                                    color: 'error.main',
                                    opacity: hoveredItemId === choice.id ? 1 : 0
                                  }}>
                                  <Iconify icon="solar:trash-bin-trash-bold" />
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                        />
                      }
                    />
                  </Box>
                ))}
              </RadioGroup>
            )}
          />
        </FormControl>
      </div>
      <Button
        color="primary"
        onClick={handleAddChoice}
        sx={{mt: 2, mb: 2, maxWidth: '125px'}}>
        Add Choice
      </Button>
    </>
  );
};

export default SingleQuestionTypeFeedback;
